// THE ONE PLACE a conversation is named. App.jsx (chat title, spotlight rows)
// and Sidebar.jsx (list rows) each grew their own copy of this and drifted —
// the sidebar knew about persona/plugin DMs, the title didn't. Merged here so
// every surface that prints a conversation's name prints the same one.

/** Display name for a DM channel — persona/plugin identity first, then a
 *  custom (renamed) name, then the group-DM member list, then the other
 *  party's username. */
export function dmDisplayName(ch, fallback = 'DM') {
  if (ch?.is_persona_dm) return ch.agent_name || 'Agent'
  if (ch?.is_plugin_dm) return ch.plugin_name || 'Plugin'
  // Custom-renamed DM (auto-generated names keep the dm- prefix)
  if (ch?.name && !ch.name.startsWith('dm-')) return ch.name
  if (ch?.is_group_dm && ch?.member_usernames?.length > 0)
    return ch.member_usernames.map((m) => m.username).join(', ')
  return ch?.other_username || fallback
}

/** Display name for ANY conversation — group channels wear their hash. */
export function convoDisplayName(ch, fallback = 'DM') {
  if (!ch) return ''
  if (ch.is_dm) return dmDisplayName(ch, fallback)
  return `#${ch.name}`
}
